export default "__VITE_ASSET__Wq1subSq__"